import React, { useEffect, useState } from "react";
// import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "draft-js/dist/Draft.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from "draft-js-export-html";
import swal from "sweetalert";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { div } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { makeStyles } from "@material-ui/core/styles";
import TextareaField from "../TextAreaField";
import {
  postMentorSessionMinutes,
  detailsGroupSession,
} from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import { cohortCreateDiscussionPost } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 0px",
  },
}));
function CreateThread(props) {
  let loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const { cohortCreateDiscussionPost, cohortId, mode, threadData,setModalVisibility,setThreadIndex } = props;
  //   const { ,fromPage } = props;
  const [hideButtons, setHideButtons] = useState(true);
  const [uploadPressed,setUploadPressed] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");
  const hoursData = [{}];
  const [discussonSummary, setDiscussonSummary] = useState("");
  const [threadUpload, setThreadUpload] = useState();
  const classes = useStyles();
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the notes"
  );
  const [showError, setShowError] = useState(false);
  const [showError2, setShowError2] = useState(false);
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [sessionHoursError, setSessionHoursError] = useState(false);
  const [venueCounter, setVenueCounter] = useState(0);
  const [directionsCounter, setDirectionCounter] = useState(0);
  const [addressCounter, setAddressCounter] = useState(0);
  const [phNoCounter, setPhNoounter] = useState(0);
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [toggleMsg, setToggleMsg] = useState(false);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "45px",
      color: "#333",
      maxwidth: "10rem",
      fontSize: "18px",
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "black",
      };
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  hoursData.push(
    {
      value: "0",
      label: "0.5",
    },
    { value: "1", label: "1" },
    { value: "2", label: "1.5" },
    { value: "3", label: "2" },
    { value: "4", label: "2.5" },
    { value: "5", label: "3" },
    { value: "6", label: "3.5" },
    { value: "7", label: "4" },
    { value: "8", label: "4.5" },
    { value: "9", label: "5" },
    { value: "10", label: "5.5" },
    { value: "11", label: "6" }
  );

  const handleClose = () => {
    setUploadPressed(false)
    setModalVisibility(false);
    setThreadIndex(-1);
    setHideButtons(true);
    setDiscussonSummary("");
    setThreadUpload();
  };

  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 251) {
      setWordCounter(250);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const handleSubmit = () => {
    if (
      title !== undefined &&
      title !== null &&
      title !== "" &&
      summary !== undefined &&
      summary !== null &&
      summary !== ""
    ) {
      setShowError(false);
      setShowError2(false);
   
   
      let params
      if(mode == "Edit") {
        params = {
          cohortId: cohortId,
          postMessage: summary,
          postTopic: title,
          postId: threadData?.postId,
          postAttach:threadData?.postAttach,
        };
        // if(threadUpload?.uploadCreate == null || threadUpload?.uploadCreate == undefined || threadUpload?.uploadCreate == "")
        // {

        // }
      }
      else{
        params  = {
          cohortId: cohortId,
          postMessage: summary,
          postTopic: title,

        };
      }
      const formData = new FormData();

      formData.append("postData", JSON.stringify(params));
      formData.append("postAttach", threadUpload?.uploadCreate);
      cohortCreateDiscussionPost(formData,mode);
      // swal({
      //   title: "Thank You",
      //   text: `Thread Submitted Successfully`,
      //   icon: "success",
      //   // timer: 1500,
      //   // buttons: false,
      // });
      setThreadIndex(-1);
      setModalVisibility(false);
      setTimeout(() => {
        props?.parentData(true);
        // props?.setModalVisibility(false);
        setUploadPressed(false)
      }, 1000);
    } else {
      if (title == undefined || title == null || title == "")
        setShowError(true);
      if (summary == undefined || summary == null || summary == "")
        setShowError2(true);
    }
  };

  const [attendesCount, setAttendesCount] = useState("");

  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const handleInputChange = (e) => {
    setUploadPressed(true);
    setThreadUpload((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
  };
  const removeFile = (fileType) => {
    setUploadPressed(false)
    if (fileType === "uploadCreate") {
      setThreadUpload((user) => {
        return { ...user, ["uploadCreate"]: null };
      });
    }
  };

  const onEditorStateChange = (state) => {
    // console.log("state",state)
    // if (testWordLimit(state) < 251) {
    setEditorState(state);
    let text = state.getCurrentContent().getPlainText("\u0001");
    const valueHTML = stateToHTML(state.getCurrentContent());

    // if (testWordLimit(text) < 251) {
    setText(text);
    setText2(valueHTML);

    // }
    //   }
  };
  useEffect(() => {
    if (mode !== undefined && mode !== null && mode !== "" && mode == "Edit") {
      setTitle(threadData?.postTopic);
      setSummary(threadData?.postMessage);
      // setThreadUpload((user) => {
      //   return { ...user, ["uploadCreate"]: threadData?.postAttach };
      // });
    }
  }, [mode]);
  const testDocumentPresent = (item2) => {
    if (
      item2?.postAttach !== null &&
      item2?.postAttach !== undefined &&
      item2?.postAttach !== "" &&
      item2?.postAttachType !== null &&
      item2?.postAttachType !== "" &&
      item2?.postAttachType.substring(0, 11) == "application"
    )
      return true;
    else return false;
  };
  const testImagePresent = (item2) => {
    if (
      item2?.postAttach !== null &&
      item2?.postAttach !== undefined &&
      item2?.postAttach !== "" &&
      item2?.postAttachType !== null &&
      item2?.postAttachType !== "" &&
      item2?.postAttachType.substring(0, 5) == "image"
    )
      return true;
    else return false;
  };
  const testVideoPresent = (item2) => {
    if (
      item2?.postAttach !== null &&
      item2?.postAttach !== undefined &&
      item2?.postAttach !== "" &&
      item2?.postAttachType !== null &&
      item2?.postAttachType !== "" &&
      item2?.postAttachType == "video/mp4"
    )
      return true;
    else return false;
  };
  return (
    <>
      <div className="div-dialog div-dialog-centered createThreadBox" style={mode == "Edit" ? {width:"98%"}:{}}>
        <div
          // size="lg"
          // show={props.divVisibility}
          // onHide={() => {
          //   props.setdivVisibility(false);
          //   setUploadPressed(false)
          //   setDiscussonSummary("");
          //   setThreadUpload();
          // }}
          aria-labelledby="example-div-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <div className="d-flex " style={{justifyContent:"space-between"}}>
            <div className="sessionMinutesHeading2">
             {
              mode == "Edit" ? "EDIT POST" : "CREATE A POST"
             } 
            </div>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </div>
          <div>
            <div className="session-detailsdiv mt-2">
              <div className="feedback-session2 mt-2">
                <div className="row mt-2">
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding mt-2">
                    TITLE*
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox mt-3 fixdivmargindata"
                  >
                    {/* <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} /> */}
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Enter a title"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      InputProps={{ className: classes.input }}
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                    />

                    {showError && (
                      <div className="login-error-msg mt-2">
                        Please enter title
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding mt-2">
                    NOTES*
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox mt-3 fixdivmargindata"
                  >
                    {/* <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} /> */}
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Enter the notes"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      rows={5}
                      InputProps={{ className: classes.input }}
                      value={summary}
                      onChange={(e) => {
                        setSummary(e.target.value);
                      }}
                    />

                    {showError2 && (
                      <div className="login-error-msg mt-2">
                        Please enter notes
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding mt-4">
                    UPLOAD DOCUMENT
                  </div>
                  <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                  { mode == "Edit" && !uploadPressed &&
                    <>
                      {testImagePresent(threadData) && (
                        <div>
                          <img
                            className="cohortDiscussionImage3"
                            src={threadData?.postAttach}
                          />
                        </div>
                      )}
                      {testDocumentPresent(threadData) && (
                        <div className="cohortPdfBox2">
                          <div
                            className="fileName2"
                            onClick={() => {
                              window
                                .open(threadData?.postAttach, "_blank")
                                .focus();
                            }}
                          >
                            View Attachment
                          </div>
                        </div>
                      )}
                   
                      {testVideoPresent(threadData) && (
                                            <div
                                              className="cohortPdfBox2"
                                              style={{
                                                // marginLeft: "6rem",
                                                width: "100%",
                                                marginLeft:"0"
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  width: "100%",
                                                }}
                                              >
                                                <div style={{ width: "100%" }}>
                                                  <>
                                                    {toggleMsg && (
                                                      <div className="overlayText">
                                                        <p className="topText">
                                                          Please wait a few
                                                          moments, video is
                                                          loading ...
                                                        </p>
                                                      </div>
                                                    )}

                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                      className="statusiconsmodal newcompletediconsabove"
                                                    >
                                                      <video
                                                        id={"video"}
                                                        width="100%"
                                                        height="100%"
                                                        controls
                                                        preload="auto"
                                                        autoplay="autoplay"
                                                        onLoadedData={() => {
                                                          setToggleMsg(false);
                                                        }}
                                                      >
                                                        <source
                                                          src={
                                                            threadData?.postAttach
                                                          }
                                                          type="video/mp4"
                                                        />
                                                      </video>
                                                    </div>
                                                  </>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                    </>}
                    <div>
                      <div className="newuserTooltip">
                        <div className="d-flex">
                          <div className="top-btn">
                            <button
                              onClick={clickonFileinput}
                              className="newUploadBtn mt-4"
                            >
                              CLICK TO UPLOAD
                            </button>
                            <span
                              className="tooltiptext   tooltip-bottom"
                              style={{
                                top: "47px",
                                left: "89px",
                                width: "auto",
                              }}
                            >
                              Upload Document
                            </span>
                          </div>
                          <div style={{ marginLeft: "1rem" }}>
                            {threadUpload && threadUpload?.uploadCreate !== null && (
                              <div style={{ marginBottom: "50px" }}>
                                <div
                                  className="file-name"
                                  style={{ float: "left" }}
                                >
                                  {threadUpload?.uploadCreate?.name?.length > 20
                                    ? threadUpload?.uploadCreate?.name.substring(
                                        0,
                                        20
                                      ) + "..."
                                    : threadUpload?.uploadCreate?.name}
                                  <span
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => removeFile("uploadCreate")}
                                  >
                                    {" "}
                                    X{" "}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <p className="wordCounter" style={{ marginTop: "10px" }}>
                        <span>
                          Supported file format PDF,JPEG,PNG,MP4,DOCX,XLS only upto
                          10MB
                        </span>
                      </p>
                      <div className="fileupload-resume-startup">
                        <input
                          className="resume-upload"
                          type="file"
                          id="fileUpload-resume"
                          required
                          name="uploadCreate"
                          onChange={handleInputChange}
                          accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx,.mp4"
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center feedBackFooterFix2">
            <div className="d-flex justify-between">
              <div>
                <Button
                  onClick={handleClose}
                  text="CANCEL"
                  className="divButton3 doc-upload"
                ></Button>
              </div>

              <div>
                <Button
                  onClick={handleSubmit}
                  text="SUBMIT"
                  className="divButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
  };
};

export default connect(mapStateToProps, {
  postMentorSessionMinutes,
  detailsGroupSession,
  cohortCreateDiscussionPost,
})(withRouter(CreateThread));
